import { ADD_NEW_KITCHEN_ORDER, REMOVE_KITCHEN_ORDER, RESET_KITCHEN_ORDERS_STATE, SET_KITCHEN_CONFIG, SET_KITCHEN_MONITOR_CONFIG, SET_KITCHEN_MONITOR_CONFIG_IS_LOADING, SET_KITCHEN_MONITOR_CONFIG_IS_SKELETON, SET_KITCHEN_MONITOR_CONFIGS, SET_KITCHEN_MONITOR_CONFIGS_UPDATE, SET_KITCHEN_ORDERS, SET_KITCHEN_ORDERS_IS_LOADING, SET_KITCHEN_ORDERS_LOADING, SET_KITCHEN_ORDERS_TOTAL_LENGTH, SET_KITCHEN_SELECTED_ORDER, SET_SHOW_KITCHEN_MONITOR_SKELETON, UPDATE_KITCHEN_ORDER } from '../../actionTypes/kitchenMonitor'

const initialState = {
	kitchenOrders: [],
	selectedKitchenOrder: null,
	ordersTotalLength: 0,
	kitchenMonitorConfigs: [],
	kitchenMonitorConfig: null,
	kitchenMonitorConfigIsLoading: false,
	config: null,
	ordersLoading: false,
	kitchenOrdersIsLoading: false,
	kitchenMonitorConfigIsSkeleton: true,
	showKitchenMonitorSkeleton: false
}

export function kitchenMonitorReducer (state = initialState, action) {
	switch (action.type) {
		case RESET_KITCHEN_ORDERS_STATE:
			return {
				...state,
				kitchenOrders: [],
				selectedKitchenOrder: null,
				ordersTotalLength: 0,
				ordersLoading: false,
				kitchenOrdersIsLoading: false,
			}
		case SET_KITCHEN_ORDERS:
			return {
				...state,
				kitchenOrders: action.value,
			}
		case SET_KITCHEN_ORDERS_TOTAL_LENGTH:
			return {
				...state,
				ordersTotalLength: action.value,
			}
		case SET_KITCHEN_SELECTED_ORDER:
			return {
				...state,
				selectedKitchenOrder: action.value,
			}
		case ADD_NEW_KITCHEN_ORDER:
			let ordersNewCopy = [...state.kitchenOrders]
			ordersNewCopy.push(action.value)
			return {
				...state,
				kitchenOrders: ordersNewCopy,
			}
		case UPDATE_KITCHEN_ORDER:
			let ordersUpdateCopy = [...state.kitchenOrders]
			const orderToUpdate = ordersUpdateCopy.find(order => order.orderId === action.value.orderId)
			if (orderToUpdate) {
				ordersUpdateCopy[ordersUpdateCopy.indexOf(orderToUpdate)] = action.value
			}
			return {
				...state,
				kitchenOrders: ordersUpdateCopy,
			}
		case REMOVE_KITCHEN_ORDER:
			let ordersRemovedCopy = [...state.kitchenOrders]
			ordersRemovedCopy = ordersRemovedCopy.filter(order => order?.orderId !== action.value.orderId)
			return {
				...state,
				kitchenOrders: ordersRemovedCopy,
			}
		case SET_KITCHEN_MONITOR_CONFIGS:
			return {
				...state,
				kitchenMonitorConfigs: action.value,
			}
		case SET_KITCHEN_MONITOR_CONFIG:
			return {
				...state,
				kitchenMonitorConfig: action.value,
			}
		case SET_KITCHEN_MONITOR_CONFIG_IS_LOADING:
			return {
				...state,
				kitchenMonitorConfigIsLoading: action.value,
			}
		case SET_KITCHEN_CONFIG:
			return {
				...state,
				config: action.value,
			}
		case SET_KITCHEN_ORDERS_LOADING:
			return {
				...state,
				ordersLoading: action.value,
			}
		case SET_KITCHEN_MONITOR_CONFIGS_UPDATE:
			return {
				...state,
				kitchenMonitorConfigs: [...state.kitchenMonitorConfigs].map((config) => (config.id === action.value.id ? action.value : config))
			}
		case SET_KITCHEN_ORDERS_IS_LOADING:
			return {
				...state,
				kitchenOrdersIsLoading: action.value,
			}
		case SET_KITCHEN_MONITOR_CONFIG_IS_SKELETON:
			return {
				...state,
				kitchenMonitorConfigIsSkeleton: action.value,
			}
		case SET_SHOW_KITCHEN_MONITOR_SKELETON:
			return {
				...state,
				showKitchenMonitorSkeleton: action.value,
			}
		default:
			return state
	}
}
